import React from 'react'

// below is a font that we pull from adobe -- the same font we use
// for the title of our candles.
export default () => (
    <link rel="stylesheet" href="https://use.typekit.net/vmh4vgi.css" />
)
